// extracted by mini-css-extract-plugin
module.exports = {"smallPadd":"Video_smallPadd__4pstW","paragraph":"Video_paragraph__t9uvA","button":"Video_button__e3D5L"};